<template>
  <Popover ref="orderedPopover" :showHeader="true" headerTitle="Ordered Glass">
    <div class="glass-size-info-popover-content">
      <Spinner v-if="loading" />
      <StaticDataTable class="static-table-list" v-if="!loading && glassSize && glassSize.orders.length > 0" variant="table-sm">
        <template v-slot:header>
          <tr>
            <th>Order</th>
            <th>Customer</th>
            <th>Status</th>
            <th>Estimated Date</th>
            <th>Stock</th>
            <th>Processed</th>
          </tr>
        </template>
        <template v-slot:body>
          <tr v-for="order in glassSize.orders" :key="order.id">
            <td class="font-weight-bold">
              <LinkOrder :id="order.id" :name="order.sequenceNumber ? order.sequenceNumber : 'Order'" />
            </td>
            <td>
              <LinkContact :id="order.contact.id" :name="order.contact.name" />
            </td>
            <td>
              <LabelBadge :labelClass="`label-order-status-${order.status}`">{{order.status | formatLookupName(OrderStatusTypeLookup)}}</LabelBadge>
              <LabelBadge labelClass="label-order-hold ml-1" v-if="order.isOnHold">Hold</LabelBadge>
            </td>
            <td>
              <span v-if="order.dateEstimated">{{order.dateEstimated | formatDate}}</span>
              <span v-else>Unknown</span>
            </td>
            <td>{{order.sheetsOrdered}}</td>
            <td>{{order.processedOrdered}}</td>
          </tr>
          <tr class="static-datatable-row-nostripe border-top table-totals-row" v-if="glassSize.orders.length > 0">
            <td colspan="4" class="text-right">Totals:</td>
            <td>{{totalSheetsOrdered}}</td>
            <td>{{totalProcessedOrdered}}</td>
          </tr>
        </template>
        <template v-slot:empty v-if="!glassSize.orders || glassSize.orders.length == 0">No stock currently ordered</template>
      </StaticDataTable>
      
    </div>
  </Popover>
</template>

<style scoped>
.glass-size-info-popover-content {
  padding: 6px;
  min-width: 400px;
  max-height: 300px;
  overflow-x: hidden;
  overflow-y: scroll;
}
</style>

<script>
import Popover from '@/components/popover.vue'
import StaticDataTable from '@/components/table/staticDataTable.vue'

import { OrderStatusTypeLookup } from '@/store/types'

export default {
  name: 'GlassSizeOrderedPopover',
  components: {
    Popover,
    StaticDataTable
  },
  data() {
    return {
      loading: false,
      stockId: null,
      glassSizeId: null,
      glassSize: null
    }
  },
  computed: {
    totalSheetsOrdered() {
      if(this.glassSize && this.glassSize.orders) {
        return this.glassSize.orders.reduce((sheetCount, order) => sheetCount + order.sheetsOrdered, 0)
      }
      return 0
    },
    totalProcessedOrdered() {
      if(this.glassSize && this.glassSize.orders) {
        return this.glassSize.orders.reduce((sheetCount, order) => sheetCount + order.processedOrdered, 0)
      }
      return 0
    }
  },
  created() {
    this.OrderStatusTypeLookup = OrderStatusTypeLookup
  },
  mounted() {
    
  },
  methods: {
    requestData() {
      this.loading = true
      this.$apiService.inventoryService.getGlassSize(this.stockId, this.glassSizeId)
      .then(response => {
        this.glassSize = response.data
      })
      .finally(() => {
        this.loading = false
      })
    },
    displayFromElement(element, stockId, glassSizeId) {
      this.stockId = stockId
      this.glassSizeId = glassSizeId
      this.glassSize = null
      this.requestData()

      this.$refs.orderedPopover.displayFromElement(element)
    }
  }

}
</script>